import useFramerTransition from "@/hooks/use-transition";
import SectionHeroLayout3 from "@/components/sections/section-hero-layout-3";
import SectionPartnersLayout2 from "@/components/sections/section-partners-layout-2";
import SectionBenefits from "@/components/sections/section-benefits";
import SectionIconBoxesLayout2 from "@/components/sections/section-icon-boxes-layout-2";
import SectionTestimonialsSliderLayout2 from "@/components/sections/section-testimonials-slider-layout-2";
import SectionFAQ from "@/components/sections/section-faq";
import SectionCTALayout3 from "@/components/sections/section-cta-layout-3";
import { Helmet } from "react-helmet";

const Homepage = useFramerTransition(
  <>
    <Helmet>
      <title>Visa World</title>
    </Helmet>
    <main className="relative">
      <SectionHeroLayout3 />
      <SectionIconBoxesLayout2 />
      <SectionPartnersLayout2 />
      <SectionBenefits />
     
      <SectionTestimonialsSliderLayout2 />
      <SectionFAQ />
      <SectionCTALayout3 />
    </main>
  </>,
);

export default Homepage;
